import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "vb_wine_basket_v2";
const BasketContext = createContext(null);

export function BasketProvider({ children }) {
  const [items, setItems] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (_) {}
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (_) {}
  }, [items]);

  const add = useCallback((wine, qty = 1) => {
    setItems((prev) => {
      const cur = prev[wine.slug]?.quantity || 0;
      return { ...prev, [wine.slug]: { slug: wine.slug, name: wine.name, price: wine.price, quantity: cur + qty } };
    });
  }, []);

  const setQty = useCallback((slug, qty) => {
    setItems((prev) => {
      const clean = { ...prev };
      if (qty <= 0) { delete clean[slug]; return clean; }
      if (!clean[slug]) return prev;
      clean[slug] = { ...clean[slug], quantity: Math.min(qty, 999) };
      return clean;
    });
  }, []);

  const remove = useCallback((slug) => {
    setItems((prev) => { const c = { ...prev }; delete c[slug]; return c; });
  }, []);

  const clear = useCallback(() => setItems({}), []);

  const list = Object.values(items);
  const totalBottles = list.reduce((s, i) => s + i.quantity, 0);
  const totalPrice = list.reduce((s, i) => s + i.quantity * (i.price || 0), 0);

  return (
    <BasketContext.Provider value={{ items: list, totalBottles, totalPrice, add, setQty, remove, clear, open, setOpen }}>
      {children}
    </BasketContext.Provider>
  );
}

export function useBasket() {
  const ctx = useContext(BasketContext);
  if (!ctx) throw new Error("useBasket must be used within BasketProvider");
  return ctx;
}
